import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { RegistrationProvider } from "./context/RegistrationContext";
import { CelebRegistrationProvider } from "./context/CelebRegistrationContext";
import ProtectedRoute from "./auth/ProtectedRoute";

import HomePage from "./components/home/homePage.jsx";
import LoginCelebrity from "./auth/celebrity-login.jsx";
import LoginModal from "./auth/login.jsx";
import FanDashboard from "./components/fandashboard/index.jsx";
import CelebDashboard from "./components/celebdashboard/index.jsx";
import BookingPopup from "./components/booking/bookingPopup.jsx";
import Registerstepone from "./auth/register/registerstepone.jsx";
import Register from "./auth/register/register.jsx";
import Fanregisterstepone from "./auth/register/fanregisterstepone.jsx";
import FanAccounts from "./components/fandashboard/accounts/index.jsx";
import CelebRegister from "./auth/register/celeb-register.jsx";
import CelebAccounts from "./components/celebdashboard/accounts/celeb-account.jsx";
import CelebrityList from "./components/celebrities/celebrityList.jsx";
import CurrentOrder from "./components/fandashboard/orders/currentOrder.jsx";
import Profile from "./components/fandashboard/profile/index.jsx";
import UnauthorizedPage from "./auth/UnauthorizedPage.jsx";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OrderStart from "./components/celebdashboard/orders/orderStart.jsx";
import CelebCompletedOrders from "./components/celebdashboard/orders/completed.jsx";
import SearchCeleb from "./components/celebrities/searchcelebs/search-celeb.jsx";
import ProfileSetting from "./components/celebdashboard/profile/profile.jsx";
import CelebEvents from "./components/celebdashboard/events/index.jsx";
import PublicEvents from "./components/events/PublicEvents.jsx";
import EmailOtp from "./auth/email-otp.jsx";
import LoginEmailOtp from "./auth/login-email-otp.jsx";
import CelebLoginEmailOtp from "./auth/CelebLoginEmailOtp.jsx";
import CelebEmailOtp from "./auth/CelebEmailOtp.jsx";
import ForgetPassword from "./auth/forgetPassword.jsx";
import ResetOtp from "./auth/resetOtp.jsx";
import ResetPassword from "./auth/resetPassword.jsx";
import ForgotPassword2 from "./auth/forgotPassword2.jsx";
import ResetOtp2 from "./auth/resetOtp2.jsx";
import ResetPassword2 from "./auth/resetPassword2.jsx";
import Error404 from "./auth/error404.jsx";
import GuestRoute from "./auth/GuestRoute.jsx";
import WhatsAppWidget from "./components/WhatsAppWidget.jsx";

function App() {
  return (
    <RegistrationProvider>
      <CelebRegistrationProvider>
        <AuthProvider>
          <BrowserRouter>
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
            
            <WhatsAppWidget />

            <Routes>
              {/* Public routes */}
              <Route path="/" element={<HomePage />} />
              <Route
                path="/celebrity-login"
                element={
                  <GuestRoute>
                    <LoginCelebrity />
                  </GuestRoute>
                }
              />
              <Route
                path="/login"
                element={
                  <GuestRoute>
                    <LoginModal />
                  </GuestRoute>
                }
              />

              <Route
                path="/email-otp"
                element={
                  <GuestRoute>
                    <LoginEmailOtp />
                  </GuestRoute>
                }
              />
              <Route
                path="/eotp"
                element={
                  <GuestRoute>
                    <EmailOtp />
                  </GuestRoute>
                }
              />
              <Route
                path="/forgot-password"
                element={
                  <GuestRoute>
                    <ForgetPassword />
                  </GuestRoute>
                }
              />
              <Route
                path="/reset-otp"
                element={
                  <GuestRoute>
                    <ResetOtp />
                  </GuestRoute>
                }
              />
              <Route
                path="/reset-password"
                element={
                  <GuestRoute>
                    <ResetPassword />
                  </GuestRoute>
                }
              />

              {/* Celebrity-specific login routes */}
              <Route
                path="/celeb-email-login"
                element={
                  <GuestRoute>
                    <CelebLoginEmailOtp />
                  </GuestRoute>
                }
              />
              <Route
                path="/celeb-email-otp-verify"
                element={
                  <GuestRoute>
                    <CelebEmailOtp />
                  </GuestRoute>
                }
              />

              {/* Fan-specific forgot password */}
              <Route
                path="/forgot-password2"
                element={
                  <GuestRoute>
                    <ForgotPassword2 />
                  </GuestRoute>
                }
              />
              <Route
                path="/reset-otp2"
                element={
                  <GuestRoute>
                    <ResetOtp2 />
                  </GuestRoute>
                }
              />
              <Route
                path="/reset-password2"
                element={
                  <GuestRoute>
                    <ResetPassword2 />
                  </GuestRoute>
                }
              />

              <Route
                path="/register"
                element={
                  <GuestRoute>
                    <Register />
                  </GuestRoute>
                }
              />
              <Route path="/unauthorized" element={<UnauthorizedPage />} />

              {/* Registration steps */}

              <Route
                path="/celeb-register"
                element={
                  <GuestRoute>
                    <CelebRegister />
                  </GuestRoute>
                }
              />
              <Route
                path="/fanregisterstepone"
                element={
                  <GuestRoute>
                    <Fanregisterstepone />
                  </GuestRoute>
                }
              />
              <Route
                path="/celebregisterstepone"
                element={
                  <GuestRoute>
                    <Registerstepone />
                  </GuestRoute>
                }
              />
              <Route path="/celebs" element={<CelebrityList />} />
              <Route path="/all-events" element={<PublicEvents />} />
              {/* Protected fan routes */}
              <Route
                path="/fan-dashboard"
                element={
                  <ProtectedRoute allowedRoles={["fan"]}>
                    <FanDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/fan-account"
                element={
                  <ProtectedRoute allowedRoles={["fan"]}>
                    <FanAccounts />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/booking"
                element={
                  <ProtectedRoute>
                    <BookingPopup />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/order"
                element={
                  <ProtectedRoute allowedRoles={["fan"]}>
                    <CurrentOrder />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/order/:orderId"
                element={
                  <ProtectedRoute allowedRoles={["fan"]}>
                    <CurrentOrder />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute allowedRoles={["celeb"]}>
                    <ProfileSetting />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile2"
                element={
                  <ProtectedRoute allowedRoles={["fan"]}>
                    <Profile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/celebs"
                element={
                  <ProtectedRoute>
                    <CelebrityList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/search-celeb"
                element={
                  <ProtectedRoute>
                    <SearchCeleb />
                  </ProtectedRoute>
                }
              />
              {/* Protected celebrity routes */}
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute allowedRoles={["celeb"]}>
                    <CelebDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/celeb-account"
                element={
                  <ProtectedRoute allowedRoles={["celeb"]}>
                    <CelebAccounts />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/completed-orders"
                element={
                  <ProtectedRoute allowedRoles={["celeb"]}>
                    <CelebCompletedOrders />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/events"
                element={
                  <ProtectedRoute allowedRoles={["celeb"]}>
                    <CelebEvents />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/celeb-account"
                element={
                  <ProtectedRoute allowedRoles={["celeb"]}>
                    <CelebAccounts />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/order-start"
                element={
                  <ProtectedRoute allowedRoles={["celeb"]}>
                    <OrderStart />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/order-start/:orderId"
                element={
                  <ProtectedRoute allowedRoles={["celeb"]}>
                    <OrderStart />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Error404 />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </CelebRegistrationProvider>
    </RegistrationProvider>
  );
}

export default App;
